export default __webpack_public_path__ + "static/099-71904a3d1cde30ebd25e9916db58e9f0.jpg";